import { render } from "./smsVerifiction.vue?vue&type=template&id=137cfb2e&scoped=true"
import script from "./smsVerifiction.vue?vue&type=script&lang=js"
export * from "./smsVerifiction.vue?vue&type=script&lang=js"

import "./smsVerifiction.vue?vue&type=style&index=0&id=137cfb2e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137cfb2e"]])

export default __exports__